module.exports = __webpack_public_path__ + "static/media/filterPage.17296c2c.txt";